// extracted by mini-css-extract-plugin
export default {"contLink":"contactsIcon_contLink__FOsXI"};